import React, { useState, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import useSnackbar from '../../../hooks/useSnackbar'; // Custom hook for Snackbar
import { DateField } from '../../../pages/Booking/Details';

export interface CustomerDateFilterData {
  startDate: string | null;
  endDate: string | null;
}

const CustomerFilter = ({
  onFiltered,
  onResetFilter,
  handleDrawerClose,
  startDate,
  endDate,
}: any) => {
  const { showSnackbar, SnackbarComponent } = useSnackbar(); // Using custom hook for Snackbar
  const [filterData, setFilterData] = useState<CustomerDateFilterData>({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    setFilterData({ startDate, endDate });
  }, [startDate, endDate]);

  // Handle form input change (start date, end date, filter type)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submit (applying the filter)
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!filterData.startDate && !filterData.endDate) {
      showSnackbar('Must Provide Start and End Date to Filter', 'warning');
      return;
    }
    if (
      filterData.startDate &&
      filterData.endDate &&
      new Date(filterData.startDate) > new Date(filterData.endDate)
    ) {
      showSnackbar('Start date cannot be greater than end date', 'warning');
      return;
    }
    onFiltered(filterData);
    handleDrawerClose();
  };

  // Handle form reset
  const handleReset = () => {
    setFilterData({
      startDate: null,
      endDate: null,
    });
    onResetFilter();
  };

  return (
    <Box sx={{ flex: 1 }}>
      {SnackbarComponent}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Start Date Field */}
        <DateField
          name="startDate"
          label="Start Date"
          type="date"
          value={filterData.startDate || ''}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
          variant="outlined"
        />

        {/* End Date Field */}
        <DateField
          name="endDate"
          label="End Date"
          type="date"
          value={filterData.endDate || ''}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
          variant="outlined"
        />

        {filterData.startDate &&
          filterData.endDate &&
          new Date(filterData.startDate) > new Date(filterData.endDate) && (
            <Typography color="warning.main" variant="body2">
              Start date cannot be greater than end date.
            </Typography>
          )}

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button type="button" variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Apply Filter
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerFilter;
